import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { CSVLink } from 'react-csv'; // Import CSVLink from react-csv
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { Tabs, Tab, Box } from '@mui/material';
import AirtableReport from '../Airtable/AirtableReport';

export default function ButtonLogs() {
  const [clients, setClients] = useState([]);
  const [qrScansLog, setQrScansLog] = useState([]);
  const [qrScansFilterLog, setQrScansFilterLog] = useState([]);

  const [search, setSearch] = useState('');
  const [filteredClients, setFilteredClients] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [qrStartDate, setQrStartDate] = useState('');
  const [qrEndDate, setQrEndDate] = useState('');

  const [countStartDate, setCountStartDate] = useState('');
  const [countEndDate, setCountEndDate] = useState('');

  const [qrCountStartDate, setQRCountStartDate] = useState('');
  const [qrCountEndDate, setQRCountEndDate] = useState('');

  const [buttonCountlogs, setButtonCountLogs] = useState([]);

  const [qrBtnScan, setQrBtnScan] = useState([]);
  const [qrFilterBtnScan, setFilterQrBtnScan] = useState([]);

  // Location logging states
  const [locationButtonLogs, setLocationButtonLogs] = useState([]);
  const [locationQrScanLogs, setLocationQrScanLogs] = useState([]);
  const [locationCountLogs, setLocationCountLogs] = useState([]);
  const [filteredLocationButtonLogs, setFilteredLocationButtonLogs] = useState([]);
  const [filteredLocationQrScanLogs, setFilteredLocationQrScanLogs] = useState([]);

  const [locationStartDate, setLocationStartDate] = useState('');
  const [locationEndDate, setLocationEndDate] = useState('');
  const [locationQrStartDate, setLocationQrStartDate] = useState('');
  const [locationQrEndDate, setLocationQrEndDate] = useState('');
  const [locationCountStartDate, setLocationCountStartDate] = useState('');
  const [locationCountEndDate, setLocationCountEndDate] = useState('');
  const [locationClientUrl, setLocationClientUrl] = useState('');

  const { userId } = useParams(); // Get the optional client ID from the route

  const [clientUrlOne, setClientUrlOne] = useState('');

  useEffect(() => {
    fetch(`/api/button-logs/${userId}`)
      .then(response => response.json())
      .then(resp => {
        const filteredClients = resp?.users;
        setClients(filteredClients);
        setFilteredClients(filteredClients);

        setQrScansLog(resp?.QrScan);
        setQrScansFilterLog(resp?.QrScan);
      })
      .catch(error => console.error('Error fetching client data:', error));

    fetchButtonLogs();
    fetchQrBtnScan();
    fetchLocationLogs();
  }, []);

  // Function to send POST request
  const fetchButtonLogs = async () => {
    try {
      const response = await axios.post('/api/button-count-logs', {
        userId: userId,
        startDate: countStartDate,
        endDate: countEndDate,
        client_url: clientUrlOne,
      });

      setButtonCountLogs(response.data.stats); // Set the logs data
    } catch (error) {
      console.error('Error fetching button logs:', error);
    }
  };

  const fetchQrBtnScan = async () => {
    try {
      const response = await axios.post('/api/qr-btnscan-count', {
        userId: userId,
        startDate: qrCountStartDate,
        endDate: qrCountEndDate,
      });

      setQrBtnScan(response.data.stats); // Set the logs data
      setFilterQrBtnScan(response.data.stats);
    } catch (error) {
      console.error('Error fetching button logs:', error);
    }
  };

  // Fetch location logs
  const fetchLocationLogs = async () => {
    try {
      const response = await axios.get(`/api/location-button-logs/${userId}`);
      console.log('Location logs response:', response.data); // Debugging log
      if (response.data) {
        setLocationButtonLogs(response.data.locationButtonLogs || []);
        setLocationQrScanLogs(response.data.locationQrScanLogs || []);
        setFilteredLocationButtonLogs(response.data.locationButtonLogs || []);
        setFilteredLocationQrScanLogs(response.data.locationQrScanLogs || []);
      }
    } catch (error) {
      console.error('Error fetching location logs:', error);
    }
  };

  // Fetch location count logs
  const fetchLocationCountLogs = async () => {
    try {
      const response = await axios.post('/api/location-button-count-logs', {
        userId: userId,
        startDate: locationCountStartDate,
        endDate: locationCountEndDate,
        client_url: locationClientUrl,
      });

      setLocationCountLogs(response.data.stats || []);
    } catch (error) {
      console.error('Error fetching location count logs:', error);
    }
  };

  useEffect(() => {
    const result = (clients || []).filter(client => {
      const clientTimestamp = new Date(client.timestamp);
      const isWithinDateRange =
        (!startDate || clientTimestamp >= new Date(startDate)) &&
        (!endDate || clientTimestamp <= new Date(endDate));

      const matchesSearch = client.client_url.toLowerCase().includes(search.toLowerCase());

      return isWithinDateRange && matchesSearch;
    });
    setFilteredClients(result);
  }, [search, clients, startDate, endDate]);

  useEffect(() => {
    // Convert qrStartDate and qrEndDate to Date objects
    const startDatee = qrStartDate ? new Date(qrStartDate) : null;
    const endDatee = qrEndDate ? new Date(qrEndDate) : null;

    // Filter the qrScansLog array
    const filteredLogs = (qrScansLog || []).filter(log => {
      const logDate = new Date(log.timestamp); // Convert log timestamp to Date object

      if (startDatee && endDatee) {
        // Filter for logs between startDate and endDate (inclusive)
        return logDate >= startDatee && logDate <= endDatee;
      } else if (startDatee) {
        // Filter for logs after startDate
        return logDate >= startDatee;
      } else if (endDatee) {
        // Filter for logs before endDate
        return logDate <= endDatee;
      } else {
        // No date filter applied, return all logs
        return true;
      }
    });

    setQrScansFilterLog(filteredLogs);
  }, [qrStartDate, qrEndDate]);

  // Filter location button logs by date
  useEffect(() => {
    const startDatee = locationStartDate ? new Date(locationStartDate) : null;
    const endDatee = locationEndDate ? new Date(locationEndDate) : null;

    const filteredLogs = (locationButtonLogs || []).filter(log => {
      const logDate = new Date(log.timestamp);

      if (startDatee && endDatee) {
        return logDate >= startDatee && logDate <= endDatee;
      } else if (startDatee) {
        return logDate >= startDatee;
      } else if (endDatee) {
        return logDate <= endDatee;
      } else {
        return true;
      }
    });

    setFilteredLocationButtonLogs(filteredLogs);
  }, [locationStartDate, locationEndDate, locationButtonLogs]);

  // Filter location QR scan logs by date
  useEffect(() => {
    const startDatee = locationQrStartDate ? new Date(locationQrStartDate) : null;
    const endDatee = locationQrEndDate ? new Date(locationQrEndDate) : null;

    const filteredLogs = (locationQrScanLogs || []).filter(log => {
      const logDate = new Date(log.timestamp);

      if (startDatee && endDatee) {
        return logDate >= startDatee && logDate <= endDatee;
      } else if (startDatee) {
        return logDate >= startDatee;
      } else if (endDatee) {
        return logDate <= endDatee;
      } else {
        return true;
      }
    });

    setFilteredLocationQrScanLogs(filteredLogs);
  }, [locationQrStartDate, locationQrEndDate, locationQrScanLogs]);

  useEffect(() => {
    // Convert qrStartDate and qrEndDate to Date objects

    fetchQrBtnScan();
  }, [qrCountStartDate, qrCountEndDate]);

  useEffect(() => {
    fetchButtonLogs();
  }, [countEndDate, countStartDate, clientUrlOne]);

  useEffect(() => {
    fetchLocationCountLogs();
  }, [locationCountStartDate, locationCountEndDate, locationClientUrl]);

  const languageNames = {
    en: 'English', es: 'Español', fr: 'Français', de: 'Deutsch', it: 'Italiano',
    pt: 'Português', ru: 'Русский', ja: '日本語', ko: '한국어', zh: '中文',
    ar: 'العربية', hi: 'हिन्दी', nl: 'Nederlands', sv: 'Svenska', da: 'Dansk',
    no: 'Norsk', fi: 'Suomi', pl: 'Polski', tr: 'Türkçe', th: 'ไทย',
    vi: 'Tiếng Việt', id: 'Bahasa Indonesia', ms: 'Bahasa Melayu', tl: 'Filipino',
  };
  const getLanguageName = (code) => languageNames[code] || (code ? code.toUpperCase() : 'English');

  const formatTimestamp = timestamp => {
    const date = new Date(timestamp);
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };
    return date.toLocaleString('en-US', options).replace(',', '');
  };

  const columns = [
    {
      name: 'Date / Time',
      selector: row => formatTimestamp(row.timestamp),
      sortable: true,
      width: '250px',
    },
    {
      name: 'Clicked Button',
      selector: row => row.clickedButton || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.clickedButton ? row.clickedButton : ''}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Language',
      selector: row => getLanguageName(row.language),
      sortable: true,
      width: '130px',
    },
    {
      name: 'Client URL',
      selector: row => row.client_url || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          <Link
            to={`/${row.client_url}`}
            target="_blank"
            style={{
              textDecoration: 'underline',
              color: 'blue',
              padding: '10px',
              borderRadius: '8px',
            }}
          >
            {row.client_url}
          </Link>
        </div>
      ),
      sortable: true,
      width: '200px',
    },
  ];

  const columns2 = [
    {
      name: 'Button Name',
      selector: row => row?.clickedButton || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row?.clickedButton ? row?.clickedButton : ''}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Clicks',
      selector: row => row?.count || 0,
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row?.count ? row?.count : 0}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'QR Scans',
      selector: row => row?.qrCount || 0,
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row?.qrCount ? row?.qrCount : 0}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Client URL',
      selector: row => row?.client_url || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row?.client_url ? row?.client_url : ''}
        </div>
      ),
      sortable: true,
    },
  ];

  const columns3 = [
    {
      name: 'Date / Time',
      selector: row => formatTimestamp(row.timestamp),
      sortable: true,
      width: '250px',
    },
    {
      name: 'Scanned Button',
      selector: row => row.scannedBtn || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.scannedBtn ? row.scannedBtn : ''}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Client Url',
      selector: row => row.client_url || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.client_url ? row.client_url : ''}
        </div>
      ),
      sortable: true,
    },
  ];

  const columns4 = [
    {
      name: 'Scan Button',
      selector: row => row.scannedBtn || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.scannedBtn ? row.scannedBtn : ''}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Count',
      selector: row => row.count || 0,
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.count ? row.count : ''}
        </div>
      ),
      sortable: true,
    },
  ];

  // Location button logs columns
  const locationButtonColumns = [
    {
      name: 'Date / Time',
      selector: row => formatTimestamp(row.timestamp),
      sortable: true,
      width: '250px',
    },
    {
      name: 'Location Name',
      selector: row => row.clickedLocationName || '',
      cell: row => (
        <div style={{ maxWidth: '250px', maxHeight: '200px', overflow: 'auto', whiteSpace: 'pre-wrap' }}>
          {row.clickedLocationName ? row.clickedLocationName : ''}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Language',
      selector: row => getLanguageName(row.language),
      sortable: true,
      width: '130px',
    },


    {
      name: 'Client URL',
      selector: row => row.client_url || '',
      cell: row => (
        <div
          style={{
            maxWidth: '200px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          <Link
            to={`/${row.client_url}`}
            target="_blank"
            style={{
              textDecoration: 'underline',
              color: 'blue',
              padding: '10px',
              borderRadius: '8px',
            }}
          >
            {row.client_url}
          </Link>
        </div>
      ),
      sortable: true,
      width: '200px',
    },
  ];

  // Location QR scan logs columns
  const locationQrColumns = [
    {
      name: 'Date / Time',
      selector: row => formatTimestamp(row.timestamp),
      sortable: true,
      width: '250px',
    },
    {
      name: 'Location Name',
      selector: row => row.scannedLocationName || '',
      cell: row => (
        <div style={{ maxWidth: '250px', maxHeight: '200px', overflow: 'auto', whiteSpace: 'pre-wrap' }}>
          {row.scannedLocationName ? row.scannedLocationName : ''}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Language',
      selector: row => getLanguageName(row.language),
      sortable: true,
      width: '130px',
    },
    {
      name: 'Client URL',
      selector: row => row.client_url || '',
      cell: row => (
        <div style={{ maxWidth: '200px', maxHeight: '200px', overflow: 'auto', whiteSpace: 'pre-wrap' }}>
          {row.client_url ? row.client_url : ''}
        </div>
      ),
      sortable: true,
    },
  ];

  // Location count logs columns
  const locationCountColumns = [
    {
      name: 'Location Name',
      selector: row => row.clickedLocationName || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.clickedLocationName ? row.clickedLocationName : ''}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Button Clicks',
      selector: row => row.count || 0,
      cell: row => (
        <div
          style={{
            maxWidth: '150px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.count ? row.count : 0}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'QR Scans',
      selector: row => row.qrCount || 0,
      cell: row => (
        <div
          style={{
            maxWidth: '150px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.qrCount ? row.qrCount : 0}
        </div>
      ),
      sortable: true,
    },

    {
      name: 'Client URL',
      selector: row => row.client_url || '',
      cell: row => (
        <div
          style={{
            maxWidth: '200px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.client_url ? row.client_url : ''}
        </div>
      ),
      sortable: true,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        marginBottom: '10px',
        padding: '10px 0',
        borderBottom: '1px solid #ccc',
      },
    },
    tableWrapper: {
      style: {
        overflowX: 'auto',
      },
    },
    headCells: {
      style: {
        fontWeight: 'bold', // Bold header text
        fontSize: '16px', // Increase font size
        backgroundColor: '#f4f4f4', // Light gray background
      },
    },
  };

  // Prepare data for CSV export
  const csvData = (filteredClients || []).map(client => ({
    'Date / Time': formatTimestamp(client.timestamp),
    'Clicked Button': client.clickedButton || '',
    'Language': getLanguageName(client.language),
    'Client URL': client.client_url || '',
  }));

  const csvButtonCountData = (buttonCountlogs || []).map(client => ({
    'Button Name': client?.clickedButton || '',
    Clicks: client?.count || 0,
    'QR Scans': client?.qrCount || 0,
    'Client URL': client?.client_url || 0,
  }));

  const csvscannedBtn = (qrBtnScan || []).map(client => ({
    'Scan Button': client.scannedBtn || '',
    Count: client.count || 0,
  }));

  const QRcsvButtonCountData = (qrScansFilterLog || []).map(client => ({
    'Date / Time': formatTimestamp(client.timestamp),
    'Scanned Button': client?.scannedBtn || '',
    'Client Url': client?.client_url,
  }));

  // Location logs CSV data
  const locationButtonCsvData = (filteredLocationButtonLogs || []).map(log => ({
    'Date / Time': formatTimestamp(log.timestamp),
    'Location Name': log.clickedLocationName || '',
    'Language': getLanguageName(log.language),
    'Client URL': log.client_url || '',
  }));

  const locationQrCsvData = (filteredLocationQrScanLogs || []).map(log => ({
    'Date / Time': formatTimestamp(log.timestamp),
    'Location Name': log.scannedLocationName || '',
    'Language': getLanguageName(log.language),
    'Client URL': log.client_url || '',
  }));

  const locationCountCsvData = (locationCountLogs || []).map(log => ({
    'Location Name': log.clickedLocationName || '',
    'Button Clicks': log.count || 0,
    'QR Scans': log.qrCount || 0,

    'Client URL': log.client_url || '',
  }));

  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    fetchButtonLogs();
  }, [countEndDate, countStartDate, clientUrlOne]);

  return (
    <div className="main-container">
      <div className="pd-ltr-20 xs-pd-20-10">
        <div className="min-height-200px">
          <div className="page-header">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="title">
                  <h4>Interaction Report</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="dashboard-container">
            <Box sx={{ width: '100%' }}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                aria-label="tab navigation"
                sx={{
                  '& .MuiTab-root': { minWidth: 100 }, // Ensures consistent width
                  '& .Mui-selected': { fontWeight: 'bold' }, // Active tab styling
                }}
              >
                <Tab
                  sx={{
                    '&:hover': {
                      fontWeight: 'bold',

                      color: '#fff',
                    },
                  }}
                  label="Interactions"
                />

                <Tab
                  sx={{
                    '&:hover': {
                      fontWeight: 'bold',

                      color: '#fff',
                    },
                  }}
                  label="Buttons Logs"
                />

                <Tab
                  sx={{
                    '&:hover': {
                      fontWeight: 'bold',

                      color: '#fff',
                    },
                  }}
                  label="Button QR Scan Logs"
                />

                <Tab
                  sx={{
                    '&:hover': {
                      fontWeight: 'bold',

                      color: '#fff',
                    },
                  }}
                  label="Airtable Button Count"
                />

                <Tab
                  sx={{
                    '&:hover': {
                      fontWeight: 'bold',

                      color: '#fff',
                    },
                  }}
                  label="Airtable Interactions Log"
                />

                <Tab
                  sx={{
                    '&:hover': {
                      fontWeight: 'bold',
                      color: '#fff',
                    },
                  }}
                  label="Location Interactions"
                />

                <Tab
                  sx={{
                    '&:hover': {
                      fontWeight: 'bold',
                      color: '#fff',
                    },
                  }}
                  label="Location Button Logs"
                />

                <Tab
                  sx={{
                    '&:hover': {
                      fontWeight: 'bold',
                      color: '#fff',
                    },
                  }}
                  label="Location QR Scan Logs"
                />

                {/* <Tab sx={{
                      "&:hover": {                       
                        fontWeight:"bold",
                      
                        color:"#fff",
                        display:"none"
                      },
                    }} label="Button Scan Count" /> */}
              </Tabs>
            </Box>
            <Box sx={{ p: 3 }}>
              {value === 1 && (
                <div className="card-box mb-30">
                  <div className="pb-20">
                    <div className="p-4">
                      {/* CSV Export Button */}
                      <CSVLink
                        data={csvData}
                        filename={'button-clicked-logs.csv'}
                        className="btn btn-success"
                        style={{ padding: '10px', marginRight: '10px', float: 'right' }}
                      >
                        Download CSV
                      </CSVLink>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="date"
                          value={startDate}
                          onChange={e => setStartDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px', marginRight: '10px' }}
                        />
                        <span style={{ marginRight: '10px' }}>to</span>
                        <input
                          type="date"
                          value={endDate}
                          onChange={e => setEndDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px' }}
                        />
                      </div>
                    </div>

                    <DataTable
                      columns={columns}
                      data={filteredClients} // Use filtered data
                      pagination
                      paginationRowsPerPageOptions={[50, 100, 150, 200, 250, 300]}
                      paginationPerPage={50}
                      highlightOnHover
                      customStyles={customStyles}
                    />
                  </div>
                </div>
              )}

              {value === 0 && (
                <div className="card-box mb-30">
                  <div className="pb-20">
                    <div className="p-4">
                      {/* CSV Export Button */}
                      <CSVLink
                        data={csvButtonCountData}
                        filename={'button-clicked-logs.csv'}
                        className="btn btn-success"
                        style={{ padding: '10px', marginRight: '10px', float: 'right' }}
                      >
                        Download CSV
                      </CSVLink>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="date"
                          value={countStartDate}
                          onChange={e => setCountStartDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px', marginRight: '10px' }}
                        />
                        <span style={{ marginRight: '10px' }}>to</span>
                        <input
                          type="date"
                          value={countEndDate}
                          onChange={e => setCountEndDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px' }}
                        />
                        <input
                          type="text"
                          value={clientUrlOne}
                          onChange={e => setClientUrlOne(e.target.value)}
                          //onBlur={() => fetchButtonLogs()} // Trigger your logic here

                          className="form-control"
                          placeholder="Search By Client Url"
                          style={{ width: '250px', marginLeft: '20px' }}
                        />
                      </div>
                    </div>

                    <DataTable
                      columns={columns2}
                      data={buttonCountlogs} // Use filtered data
                      pagination
                      paginationRowsPerPageOptions={[50, 100, 150, 200, 250, 300]}
                      paginationPerPage={50}
                      highlightOnHover
                      customStyles={customStyles}
                    />
                  </div>
                </div>
              )}

              {value === 2 && (
                <div className="card-box mb-30">
                  <div className="pb-20">
                    <div className="p-4">
                      <CSVLink
                        data={QRcsvButtonCountData}
                        filename={'button-scan-logs.csv'}
                        className="btn btn-success"
                        style={{ padding: '10px', marginRight: '10px', float: 'right' }}
                      >
                        Download CSV
                      </CSVLink>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="date"
                          value={qrStartDate}
                          onChange={e => setQrStartDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px', marginRight: '10px' }}
                        />
                        <span style={{ marginRight: '10px' }}>to</span>
                        <input
                          type="date"
                          value={qrEndDate}
                          onChange={e => setQrEndDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px' }}
                        />
                      </div>
                    </div>

                    <DataTable
                      columns={columns3}
                      data={qrScansFilterLog} // Use filtered data
                      pagination
                      paginationRowsPerPageOptions={[50, 100, 150, 200, 250, 300]}
                      paginationPerPage={50}
                      highlightOnHover
                      customStyles={customStyles}
                    />
                  </div>
                </div>
              )}

              {value === 654645 && (
                <div className="card-box mb-30">
                  <div className="pb-20">
                    <div className="p-4">
                      {/* CSV Export Button */}
                      <CSVLink
                        data={csvscannedBtn}
                        filename={'button-scan-count.csv'}
                        className="btn btn-success"
                        style={{ padding: '10px', marginRight: '10px', float: 'right' }}
                      >
                        Download CSV
                      </CSVLink>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="date"
                          value={qrCountStartDate}
                          onChange={e => setQRCountStartDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px', marginRight: '10px' }}
                        />
                        <span style={{ marginRight: '10px' }}>to</span>
                        <input
                          type="date"
                          value={qrCountEndDate}
                          onChange={e => setQRCountEndDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px' }}
                        />
                      </div>
                    </div>

                    <DataTable
                      columns={columns4}
                      data={qrBtnScan} // Use filtered data
                      pagination
                      paginationRowsPerPageOptions={[50, 100, 150, 200, 250, 300]}
                      paginationPerPage={50}
                      highlightOnHover
                      customStyles={customStyles}
                    />
                  </div>
                </div>
              )}

              {(value === 4 || value === 3) && (
                <div className="card-box mb-30">
                  <AirtableReport value={value} userId={userId} />
                </div>
              )}

              {value === 5 && (
                <div className="card-box mb-30">
                  <div className="pb-20">
                    <div className="p-4">
                      <CSVLink
                        data={locationCountCsvData}
                        filename={'location-interactions-count.csv'}
                        className="btn btn-success"
                        style={{ padding: '10px', marginRight: '10px', float: 'right' }}
                      >
                        Download CSV
                      </CSVLink>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="date"
                          value={locationCountStartDate}
                          onChange={e => setLocationCountStartDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px', marginRight: '10px' }}
                        />
                        <span style={{ marginRight: '10px' }}>to</span>
                        <input
                          type="date"
                          value={locationCountEndDate}
                          onChange={e => setLocationCountEndDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px' }}
                        />
                        <input
                          type="text"
                          value={locationClientUrl}
                          onChange={e => setLocationClientUrl(e.target.value)}
                          className="form-control"
                          placeholder="Search By Client Url"
                          style={{ width: '250px', marginLeft: '20px' }}
                        />
                      </div>
                    </div>

                    <DataTable
                      columns={locationCountColumns}
                      data={locationCountLogs}
                      pagination
                      paginationRowsPerPageOptions={[50, 100, 150, 200, 250, 300]}
                      paginationPerPage={50}
                      highlightOnHover
                      customStyles={customStyles}
                    />
                  </div>
                </div>
              )}

              {value === 6 && (
                <div className="card-box mb-30">
                  <div className="pb-20">
                    <div className="p-4">
                      <CSVLink
                        data={locationButtonCsvData}
                        filename={'location-button-logs.csv'}
                        className="btn btn-success"
                        style={{ padding: '10px', marginRight: '10px', float: 'right' }}
                      >
                        Download CSV
                      </CSVLink>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="date"
                          value={locationStartDate}
                          onChange={e => setLocationStartDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px', marginRight: '10px' }}
                        />
                        <span style={{ marginRight: '10px' }}>to</span>
                        <input
                          type="date"
                          value={locationEndDate}
                          onChange={e => setLocationEndDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px' }}
                        />
                      </div>
                    </div>

                    <DataTable
                      columns={locationButtonColumns}
                      data={filteredLocationButtonLogs}
                      pagination
                      paginationRowsPerPageOptions={[50, 100, 150, 200, 250, 300]}
                      paginationPerPage={50}
                      highlightOnHover
                      customStyles={customStyles}
                    />
                  </div>
                </div>
              )}

              {value === 7 && (
                <div className="card-box mb-30">
                  <div className="pb-20">
                    <div className="p-4">
                      <CSVLink
                        data={locationQrCsvData}
                        filename={'location-qr-scan-logs.csv'}
                        className="btn btn-success"
                        style={{ padding: '10px', marginRight: '10px', float: 'right' }}
                      >
                        Download CSV
                      </CSVLink>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="date"
                          value={locationQrStartDate}
                          onChange={e => setLocationQrStartDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px', marginRight: '10px' }}
                        />
                        <span style={{ marginRight: '10px' }}>to</span>
                        <input
                          type="date"
                          value={locationQrEndDate}
                          onChange={e => setLocationQrEndDate(e.target.value)}
                          className="form-control"
                          style={{ width: '150px' }}
                        />
                      </div>
                    </div>

                    <DataTable
                      columns={locationQrColumns}
                      data={filteredLocationQrScanLogs}
                      pagination
                      paginationRowsPerPageOptions={[50, 100, 150, 200, 250, 300]}
                      paginationPerPage={50}
                      highlightOnHover
                      customStyles={customStyles}
                    />
                  </div>
                </div>
              )}
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
}
